import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "w-25" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "w-75 h-100 ps-3 text-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "左側のドキュメント一覧からドキュメントを選んでください。📕", -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "w-75 h-100 ps-3"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "position-absolute top-50 end-0 me-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "position-absolute top-50 ms-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

import { onMounted, ref } from 'vue';
import axios from 'axios';
import CoreDialog from '../../../framework/components/dialog/CoreDialog.vue';
import { DialogHandler } from './DialogHandler';
/**
 * 動的ラベル
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentSlideDialog',
  setup(__props) {

const title = ref('ドキュメント');
/**
 * プロパティ
 */
const dialogId = DialogHandler.documentSlideDialogId;

const files = ref([]);
const selectedDir = ref('');
const slide = ref('');
const index = ref(0);
const hasNext = ref(false);
const hasPrev = ref(false);

const clickSlide = (item) => {
  files.value = item.slides;
  selectedDir.value = item.dir;
  slide.value = `/public/slide/${selectedDir.value}/${files.value[0]}`;
  index.value = 0;
  hasNext.value = true;
};

const nextSlide = () => {
  index.value++;
  slide.value = files.value[index.value] ? 
    `/public/slide/${selectedDir.value}/${files.value[index.value]}` : '';
  hasNext.value = files.value[index.value] ? true : false;
  hasPrev.value = true;
};

const backSlide = () => {
  index.value--;
  slide.value = files.value[index.value] ? 
    `/public/slide/${selectedDir.value}/${files.value[index.value]}` : '';
  hasPrev.value = files.value[index.value - 1] ? true : false;
  hasNext.value = true;
};

const slides = ref([]);
onMounted(() => {
  axios.get('/public/slide/slides.json').then((json) => {
    slides.value = json.data;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CoreDialog, {
    id: _unref(dialogId),
    "dialog-class": { 'modal-fullscreen': true },
    title: title.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slides.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.dir
            }, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary w-100 my-2",
                onClick: ($event: any) => (clickSlide(item))
              }, _toDisplayString(item.fileName), 9, _hoisted_3)
            ]))
          }), 128))
        ]),
        (!slide.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("img", {
                src: '/public/logo.png',
                height: "200",
                class: "my-4"
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        (slide.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", {
                class: "img-responsive d-block w-100 h-100",
                src: slide.value,
                alt: "1",
                lazyload: ""
              }, null, 8, _hoisted_8),
              (hasNext.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "btn rounded-circle btn-outline-secondary",
                      onClick: nextSlide
                    }, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (hasPrev.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                    _createElementVNode("button", {
                      class: "btn rounded-circle btn-outline-secondary",
                      onClick: backSlide
                    }, _hoisted_14)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["id", "title"]))
}
}

})